export const MENSAGEM_INSTABILIDADE_SISTEMA =
  "O sistema pode estar passando por algum tipo de instabilidade, tente novamente em alguns minutos, se o problema persistir, procure o suporte.";

const STATUS_INSTABILIDADE = new Set([502, 503, 504]);

function flattenValidationErrors(errors) {
  if (!errors || typeof errors !== "object") return [];

  return Object.entries(errors)
    .map(([field, messages]) => {
      const text = Array.isArray(messages)
        ? messages.filter(Boolean).join(" ")
        : String(messages ?? "");
      if (!text) return null;
      return field ? `${field}: ${text}` : text;
    })
    .filter(Boolean);
}

export function isErroDeRedeOuInstabilidade(error) {
  if (!error) return false;
  if (
    error.code === "ERR_CANCELED" ||
    error.name === "CanceledError" ||
    error.name === "AbortError"
  ) {
    return false;
  }

  const status = error.response?.status;
  if (STATUS_INSTABILIDADE.has(status)) return true;

  if (error.code === "ERR_NETWORK" || error.code === "ECONNABORTED") {
    return true;
  }

  const message = String(error.message || "");
  if (/^Network Error$/i.test(message)) return true;
  if (/timeout of \d+ms exceeded/i.test(message)) return true;

  if (!error.response && error.request) return true;

  return false;
}

export function getApiErrorMessage(error, fallback = "Ocorreu um erro.") {
  if (isErroDeRedeOuInstabilidade(error)) {
    return MENSAGEM_INSTABILIDADE_SISTEMA;
  }

  const data = error?.response?.data ?? (error?.errors || error?.message || error?.detail ? error : null);

  if (data?.errors) {
    const fromErrors = flattenValidationErrors(data.errors);
    if (fromErrors.length > 0) return fromErrors.join(" ");
  }

  if (data?.detail?.errors) {
    const fromDetailErrors = flattenValidationErrors(data.detail.errors);
    if (fromDetailErrors.length > 0) return fromDetailErrors.join(" ");
  }

  if (typeof data?.detail === "string" && data.detail.trim()) {
    return data.detail;
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    const isAxiosStatusMessage = /^Request failed with status code \d+$/i.test(
      error.message,
    );
    if (!isAxiosStatusMessage) return error.message;
  }

  return fallback;
}
